import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CredentialsService } from '@core/services/credentials.service';
import {
  ApplePayPurchaseRequest,
  ApplePayStartSessionRequest,
  ApplePayStartSessionResponse,
  IApplePayRequest,
} from './payment.types';

const routes = {
  getPaymentInfo: (id: string, lang?: string) =>
    `/org/sgs/payment/link/${id}/info${lang ? `?lang=${lang}` : ''}`,
  getPaymentDetails: (id: string) =>
    `/org/sgs/payment/link/${id}?paymentGateway=1`,
  getCashinPaymentDetails: (id: string) =>
    `/org/sgs/payment/link/${id}?paymentGateway=3`,
  getApplePaySession: () => '/org/sgs/apple-pay/start-session',
  applePayPurchase: () => '/org/sgs/apple-pay/purchase',
  getPaymentStatus: (id: string) => `/org/sgs/payment/status/${id}`,
};

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(
    private httpClient: HttpClient,
    private credentialsService: CredentialsService,
  ) {}

  getPaymentInfo(id: string, lang?: string) {
    const headersConfig: { [header: string]: string } = {
      Authorization: `Bearer ${this.credentialsService.credentials?.token}`,
    };

    if (lang) {
      headersConfig['Accept-Language'] = lang;
    }
    return this.httpClient.get(`/org/sgs/payment/link/${id}/info`, {
      headers: new HttpHeaders(headersConfig),
    });
  }

  getPaymentDetails(id: string) {
    return this.httpClient.get(routes.getPaymentDetails(id), {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.credentialsService.credentials?.token}`,
      }),
    });
  }

  getCashinPaymentDetails(id: string) {
    return this.httpClient.get(routes.getCashinPaymentDetails(id), {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.credentialsService.credentials?.token}`,
      }),
    });
  }

  getApplePaySession(data: ApplePayStartSessionRequest) {
    return this.httpClient.post<ApplePayStartSessionResponse>(
      routes.getApplePaySession(),
      data,
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${this.credentialsService.credentials.token}`,
        }),
      },
    );
  }

  applePayPurchase(data: ApplePayPurchaseRequest) {
    return this.httpClient.post<IApplePayRequest>(
      routes.applePayPurchase(),
      data,
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${this.credentialsService.credentials.token}`,
        }),
      },
    );
  }

  getPaymentStatus(id: string) {
    return this.httpClient.get(routes.getPaymentStatus(id));
  }
}
